import { useState, useEffect } from "react";
import { usePrevious } from "./usePrevious.js";
const useExpand = (expanded, onExpand) => {
  const [isExpanded, setIsExpanded] = useState(expanded);
  const previousIsExpanded = usePrevious(isExpanded);
  useEffect(() => {
    if (expanded !== isExpanded) {
      setIsExpanded(expanded);
    }
  }, [expanded]);
  useEffect(() => {
    if (onExpand && isExpanded !== !!previousIsExpanded) {
      onExpand(isExpanded);
    }
  }, [isExpanded, onExpand]);
  return [isExpanded, setIsExpanded];
};
export {
  useExpand
};
//# sourceMappingURL=useExpand.js.map
